import { waterBillBundle } from "@/routes/apt/[apt_code]/analysis/_components/bill-kpi/bill-const"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import KpiCard from "@/routes/apt/[apt_code]/analysis/_components/kpi-card"
import { pdfStore } from "./pdf/pdf-store"
import { alarmStore } from "./alarm/alarm-store"
import { langStore } from "@/stores/lang-store"
import ModalOpenButton from "./modal-open-button"
import { leakChartStore } from "../leak/leak-chart-store"
import { getThisMonthWaterBill } from "../../../water-bill-util"
import Wrapper from "@/components/wrapper"

const BillKpiView = ({ className = "" }) => {
  const { lang } = langStore()
  const { region_key } = aptSearchStore((s) => s.pickApt)

  const { usageSum, leakSum, pickUnit } = leakChartStore()

  const { openModal: openPdfModal, getPdf } = pdfStore()
  const openAlertModal = alarmStore((s) => s.openModal)

  const waterBill = usageSum === 0 ? 0 : getThisMonthWaterBill(region_key, usageSum)
  const leakBill = getThisMonthWaterBill(region_key, leakSum, true)

  const generatePdfModalOpen = async () => {
    const { dong, ho, leakStartAt } = pickUnit
    await getPdf({ dong, ho, leakStartAt })
    openPdfModal()
  }

  return (
    <Wrapper.shadow className={className}>
      <div className="flex justify-end gap-3 mb-auto">
        <ModalOpenButton onClick={() => openAlertModal(pickUnit)} theme="white">
          {waterBillBundle.btnLeakAlert[lang]}
        </ModalOpenButton>
        <ModalOpenButton onClick={generatePdfModalOpen} theme="black">
          {waterBillBundle.btnGenerateNotice[lang]}
        </ModalOpenButton>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <KpiCard
          title={waterBillBundle.titleWaterBill[lang]}
          value={`${waterBill.toLocaleString()} ${waterBillBundle.unitCurrency[lang]}`}
          accent="blue"
        />
        <KpiCard
          title={waterBillBundle.titleLeakBill[lang]}
          value={`${leakBill.toLocaleString()} ${waterBillBundle.unitCurrency[lang]}`}
          accent="orange"
        />
        <KpiCard
          title={waterBillBundle.titleRatio[lang]}
          value={`${(waterBill === 0 ? 0 : (leakBill / waterBill) * 100).toFixed(1)} %`}
          accent="red"
        />
      </div>
    </Wrapper.shadow>
  )
}

export default BillKpiView
